/**
 * Defensive dedupe for retrieve-participants payloads.
 * One roster entry per userId per occurrence; fallback per handleId when user is unknown.
 */

function resolveHandleId(row) {
  if (row?.handleId != null) return String(row.handleId);
  const h0 = Array.isArray(row?.handles) ? row.handles[0] : null;
  if (h0?.id != null) return String(h0.id);
  if (h0?.handleId != null) return String(h0.handleId);
  return null;
}

export function dedupeRegisteredUsersForDisplay(users) {
  const list = Array.isArray(users) ? users : [];
  const byUserId = new Map();
  const byHandleId = new Map();
  const noKey = [];

  for (const row of list) {
    const uid = row?.userId != null ? Number(row.userId) : NaN;
    if (Number.isInteger(uid) && uid > 0) {
      if (!byUserId.has(uid)) byUserId.set(uid, row);
      continue;
    }

    const hid = resolveHandleId(row);
    if (hid) {
      if (!byHandleId.has(hid)) byHandleId.set(hid, row);
      continue;
    }

    noKey.push(row);
  }

  return [...byUserId.values(), ...byHandleId.values(), ...noKey];
}
